import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
var _excluded = ["spaceBetween", "speed", "delay", "height", "lineHeight"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Broadcast } from '@tencent/milo-core';
import Swiper, { Autoplay } from 'swiper';
import { miloAlert } from '../AlertDialog';
import './style.css';
Swiper.use([Autoplay]);
var LINE_HEIGHT = 25;

var LotteryBroadcastComp = /*#__PURE__*/function () {
  function LotteryBroadcastComp(option) {
    _classCallCheck(this, LotteryBroadcastComp);

    this.option = _objectSpread({
      iActivityId: '',
      iFlowId: '',
      flowConfig: {
        initDataUrl: '',
        // 自定义初始化数据地址
        showDataConfine: 0,
        // 真实数据小于它则用初始数据补齐
        activityId: '',
        filter: null // 轮播数据过滤器

      },
      containerId: '',
      renderItem: null,
      // 渲染一条轮播数据回调
      swipeOption: {}
    }, option);
    this.swiper = null;
    this.init();
  }

  _createClass(LotteryBroadcastComp, [{
    key: "init",
    value: function init() {
      var _this = this;

      var self = this;
      var _this$option = this.option,
          containerId = _this$option.containerId,
          onFail = _this$option.onFail,
          iFlowId = _this$option.iFlowId;

      var _this$option$swipeOpt = this.option.swipeOption,
          spaceBetween = _this$option$swipeOpt.spaceBetween,
          speed = _this$option$swipeOpt.speed,
          delay = _this$option$swipeOpt.delay,
          height = _this$option$swipeOpt.height,
          lineHeight = _this$option$swipeOpt.lineHeight,
          others = _objectWithoutProperties(_this$option$swipeOpt, _excluded);

      Broadcast(this.option).then(function (list) {
        var content = (list || []).map(function (item) {
          var sUin = item.sUin,
              sPackageName = item.sPackageName;

          if (self.option.renderItem) {
            return "<div class=\"swiper-slide\">".concat(self.option.renderItem(item), "</div>");
          }

          return "\n                            <div class=\"swiper-slide\">".concat(sUin, " \u83B7\u5F97\u4E86 ").concat(sPackageName, "</div>\n                        ");
        }).join('');
        var container = document.getElementById(containerId);

        if (!containerId || !container) {
          miloAlert('轮播组件缺少参数containerId');
          return;
        }

        container.classList.add('milo-lottery-broadcast-container');
        container.classList.add('swiper-container');
        container.style.height = "".concat(height || 50, "px");
        var contentEl = document.createElement('div');
        contentEl.classList.add('swiper-wrapper');
        contentEl.innerHTML = content;
        container.appendChild(contentEl);
        _this.swiper = new Swiper('.milo-lottery-broadcast-container', _objectSpread({
          direction: 'vertical',
          speed: Number(speed) || 500,
          height: Number(lineHeight) || LINE_HEIGHT,
          spaceBetween: Number(spaceBetween) || 0,
          loop: true,
          freeMode: true,
          autoplay: {
            delay: Number(delay) || 600
          },
          noSwiping: true
        }, others));
        container.addEventListener('mouseenter', function () {
          self.pause();
        });
        container.addEventListener('mouseleave', function () {
          self.start();
        });
      })["catch"](function (err) {
        var error = _objectSpread(_objectSpread({}, err), {}, {
          errMsg: err.errMsg ? "\u6D41\u7A0B".concat(iFlowId, "\u521D\u59CB\u5316\u5931\u8D25: ").concat(err.errMsg) : "\u6D41\u7A0B".concat(iFlowId, "\u521D\u59CB\u5316\u5931\u8D25")
        });

        if (onFail) {
          onFail(error);
        }

        console.log(error);
      });
    }
  }, {
    key: "pause",
    value: function pause() {
      this.swiper && this.swiper.autoplay && this.swiper.autoplay.stop();
    }
  }, {
    key: "start",
    value: function start() {
      this.swiper && this.swiper.autoplay && this.swiper.autoplay.start();
    }
  }]);

  return LotteryBroadcastComp;
}();

export { LotteryBroadcastComp as default };
export var LotteryBroadcast = {
  init: function init(option) {
    return new Promise(function (resolve, reject) {
      var instance;

      try {
        instance = new LotteryBroadcastComp(option);
        resolve(instance);
      } catch (e) {
        console.log(e);
        reject({
          errCode: -2,
          errMsg: '轮播模块初始化失败'
        });
      }
    });
  }
};